module.exports = __webpack_public_path__ + "img/barbieri.39be8aa2.jpg";